import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {VisitorAccessLogDto} from "../../../modules/vms/dto/VisitorAccessLogDto";
import dayjs from "dayjs";
import {Formats} from "../../../constants/Formats";
import {AccessDirection} from "../../../modules/vms/enums/AccessDirection";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "@mui/material";
import CloseButton from "../../../components/buttons/CloseButton";
import {DictClassCode} from "../../../modules/vms/constants/DictClassCode";
import {DictClassApi} from "../../../modules/dict/api/DictClassApi";
import {HttpStatus} from "../../../modules/common/enums/HttpStatus";
import {FileApi} from "../../../modules/ftp/api/FileApi";
import {DictItemDto} from "../../../modules/dict/dto/DictItemDto";
import {ImageUtils} from "../../../utils/ImageUtils";
import DownloadButton from "../../../components/buttons/DownloadButton";
import {RequestVisitorDto} from "../../../modules/vms/dto/RequestVisitorDto";

export type VisitorPhotoDialogProps = {
    open: boolean;
    requestVisitor: RequestVisitorDto;
    onClose: () => void;
};

const VisitorPhotoDialog: React.FC<VisitorPhotoDialogProps> = (props) => {
    const intl = useIntl();

    const [photo, setPhoto] = useState('');

    useEffect(() => {
        if (props.open && props.requestVisitor.portraitFileId) {
            fetchFileData(props.requestVisitor.portraitFileId);
        }
    }, [props.open]);

    const fetchFileData = async (id: string) => {
        const responseResult = await FileApi.readFile(id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            console.log(responseResult.data);
            setPhoto("data:image/png;base64," + responseResult.data);
        }
    };

    const handleClose = () => {
        props.onClose();
    };

    const handleDownload = async () => {
        await FileApi.downloadFile(props.requestVisitor.portraitFileId, props.requestVisitor.fullName);
    };

    return (
        <Dialog open={props.open} onClose={handleClose} fullWidth={true}>
            <DialogTitle>
                {intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PHOTO'})}
            </DialogTitle>
            <DialogContent>
                <img style={{width: '100%'}} src={photo}/>
            </DialogContent>
            <DialogActions>
                <CloseButton onClick={handleClose}/>
                <DownloadButton onClick={handleDownload}/>
            </DialogActions>
        </Dialog>
    );
};

export default VisitorPhotoDialog;
